import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/tranlation.json';
import es from './locales/es/translation.json';
// import ko from './locales/ko/translation.json'; 
import de from './locales/de/translation.json';
import it from './locales/it/translation.json';
import fr from './locales/fr/translation.json';
import pt from './locales/pt/translation.json';

const supportedLangs = ['en', 'es', 'de', 'it', 'fr', 'pt'];
const browserLang = navigator.language.split('-')[0];
const savedLang = localStorage.getItem('i18nextLng') || (supportedLangs.includes(browserLang) ? browserLang : 'en');

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
            // ko: { translation: ko },
            de: { translation: de },
            it: { translation: it },
            fr: { translation: fr },
            pt: { translation: pt },
        },
        lng: savedLang,
        fallbackLng: 'en',
        keySeparator: '.',
        interpolation: {
            escapeValue: false,
        },
        parseMissingKeyHandler: (key) => key,
    });

export default i18n;
